<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d6e112">The Summer Snow </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Pawe_9781569477786_epub_c2_r1.vue?5edd0a62